import { render, staticRenderFns } from "./DataAccept.vue?vue&type=template&id=166f8f61&"
import script from "./DataAccept.vue?vue&type=script&lang=js&"
export * from "./DataAccept.vue?vue&type=script&lang=js&"
import style0 from "./DataAccept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports